//----------------------------------
// create new character spell entry
//----------------------------------
export default function createNewCharacterSpellEntry({
  id, // temp id used for tracking
  static_spell, // to unpack below
  // changeable values
  mag,
  character_item,
  character_rune,
  //
  character = null,
  character_rune_name = '',
  casting_rune_name = '',
  item_name = '',
  source_name = '',
} = {}) {
  console.log('---------------------------------')
  console.log('IN createNewCharacterSpellEntry')

  let character_id = null
  if (character && typeof character === 'object') {
    character_id = character.id
  }

  // Derive a simple source label so table views can display where the
  // spell comes from (Character / Item / Rune) in a way that matches
  // the effective-spells payload.
  let source = 'Character'
  if (character_rune) {
    source = 'Rune'
  } else if (character_item) {
    source = 'Item'
  }
  //------------------
  // define structure
  //------------------
  let spell = {
    // ids
    id: id, // temp id used for tracking
    spell: static_spell.id,

    // only include character id for new spell
    ...(character ? { character: character_id } : {}),

    // changes (from SpellCard)
    mag: mag,
    character_item: character_item,
    character_rune: character_rune,
    character_rune_name: character_rune_name,

    // simple source label used by CharacterSheetSpells table
    source: source,

    // static fields
    type: static_spell.type,
    name: static_spell.name,
    range: static_spell.range,
    duration: static_spell.duration,
    area: static_spell.area,
    casting_time: static_spell.casting_time,
    resist: static_spell.resist,
    progressive: static_spell.progressive,
    triggered: static_spell.triggered,
    cult1: static_spell.cult1,
    cult2: static_spell.cult2,
    short_description: static_spell.short_description,
    description: static_spell.description,
    secondary_rune: static_spell.secondary_rune ?? null,
    secondary_rune_name: static_spell.secondary_rune_name ?? '',
    casting_rune_name: casting_rune_name,
    item_name: item_name,
    source_name: source_name,
  }
  return spell
}
